import { getPercent } from '@/shared/lib/getPercent';
import { Status } from '@/shared/types/Status';

import {
  DETERMINING_SPEAKERS_SEC,
  DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  PROJECT_CREATED_TO_UPLOADING_SEC,
  SEPARATE_BACKGROUND_SEC,
  SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC,
  TRANSCRIBING_SEGMENTS_SEC,
  TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC,
  VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC,
  VIDEO_UPLOADING_SEC,
  VOICE_SUGGESTING_SEC,
} from './mlAverageTasksDurations';

export const VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO =
  PROJECT_CREATED_TO_UPLOADING_SEC +
  VIDEO_UPLOADING_SEC +
  VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
  SEPARATE_BACKGROUND_SEC +
  SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC +
  TRANSCRIBING_SEGMENTS_SEC +
  TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC +
  DETERMINING_SPEAKERS_SEC +
  DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC +
  VOICE_SUGGESTING_SEC;
const INITIAL_PERCENT = 1;
const FINAL_PERCENT = 99;
// Рассчитанные начальные проценты для каждого статуса загрузки видео
const PROJECT_UPLOADING_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC,
  VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
);
const PROJECT_UPLOADING_TO_SEPARATE_BACKGROUND_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC + VIDEO_UPLOADING_SEC,
  VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
);
const PROJECT_SEPARATE_BACKGROUND_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC + VIDEO_UPLOADING_SEC + VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC,
  VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
);
const SEPARATE_BACKGROUND_TO_TRANSCRIBING_SEGMENTS_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC,
  VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
);
const TRANSCRIBE_SEGMENTS_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC,
  VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
);
const TRANSCRIBE_SEGMENTS_TO_DETERMINE_SPEAKERS_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_SEC,
  VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
);
const DETERMINE_SPEAKERS_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC,
  VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
);
const DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC,
  VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
);
const VOICE_SUGGEST_INITIAL_PERCENT = getPercent(
  PROJECT_CREATED_TO_UPLOADING_SEC +
    VIDEO_UPLOADING_SEC +
    VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_SEC +
    SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_SEC +
    TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_SEC +
    DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  VIDEO_UPLOADING_WITH_DST_SRT_SEC_FOR_60_SEC_VIDEO,
);
// Константы для загрузки видео
export const VIDEO_UPLOADING_WITH_DST_SRT_TASKS_SEC: {
  [key in Status]?: number;
} = {
  [Status.created]: PROJECT_CREATED_TO_UPLOADING_SEC,
  [Status.determineSpeakersDone]: DETERMINING_SPEAKERS_TO_VOICE_SUGGEST_SEC,
  [Status.determineSpeakersStarted]: DETERMINING_SPEAKERS_SEC,
  [Status.separateBackgroundDone]: SEPARATE_BACKGROUND_TO_TRANSCRIBE_SEGMENTS_SEC,
  [Status.separateBackgroundStarted]: SEPARATE_BACKGROUND_SEC,
  [Status.transcribeSegmentsDone]: TRANSCRIBING_SEGMENTS_TO_DETERMINING_SPEAKERS_SEC,
  [Status.transcribeSegmentsStarted]: TRANSCRIBING_SEGMENTS_SEC,
  [Status.uploaded]: VIDEO_UPLOADED_TO_SEPARATE_BACKGROUND_SEC,
  [Status.uploading]: VIDEO_UPLOADING_SEC,
  [Status.voiceSuggestStarted]: VOICE_SUGGESTING_SEC,
};
export const INITIAL_PERCENT_FOR_VIDEO_UPLOADING_WITH_DST_SRT_STATUS: {
  [key in Status]?: number;
} = {
  [Status.created]: INITIAL_PERCENT,
  [Status.determineSpeakersDone]: DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.determineSpeakersStarted]: DETERMINE_SPEAKERS_INITIAL_PERCENT,
  [Status.separateBackgroundDone]: SEPARATE_BACKGROUND_TO_TRANSCRIBING_SEGMENTS_INITIAL_PERCENT,
  [Status.separateBackgroundStarted]: PROJECT_SEPARATE_BACKGROUND_INITIAL_PERCENT,
  [Status.transcribeSegmentsDone]: TRANSCRIBE_SEGMENTS_TO_DETERMINE_SPEAKERS_INITIAL_PERCENT,
  [Status.transcribeSegmentsStarted]: TRANSCRIBE_SEGMENTS_INITIAL_PERCENT,
  [Status.uploaded]: PROJECT_UPLOADING_TO_SEPARATE_BACKGROUND_INITIAL_PERCENT,
  [Status.uploading]: PROJECT_UPLOADING_INITIAL_PERCENT,
  [Status.voiceSuggestStarted]: VOICE_SUGGEST_INITIAL_PERCENT, // 62
};
export const FINAL_PERCENT_FOR_VIDEO_UPLOADING_WITH_DST_SRT_STATUS: {
  [key in Status]?: number;
} = {
  [Status.created]: PROJECT_UPLOADING_INITIAL_PERCENT,
  [Status.determineSpeakersDone]: VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.determineSpeakersStarted]: DETERMINE_SPEAKERS_TO_VOICE_SUGGEST_INITIAL_PERCENT,
  [Status.separateBackgroundDone]: TRANSCRIBE_SEGMENTS_INITIAL_PERCENT,
  [Status.separateBackgroundStarted]: SEPARATE_BACKGROUND_TO_TRANSCRIBING_SEGMENTS_INITIAL_PERCENT,
  [Status.transcribeSegmentsDone]: DETERMINE_SPEAKERS_INITIAL_PERCENT,
  [Status.transcribeSegmentsStarted]: TRANSCRIBE_SEGMENTS_TO_DETERMINE_SPEAKERS_INITIAL_PERCENT,
  [Status.uploaded]: PROJECT_SEPARATE_BACKGROUND_INITIAL_PERCENT,
  [Status.uploading]: PROJECT_UPLOADING_TO_SEPARATE_BACKGROUND_INITIAL_PERCENT,
  [Status.voiceSuggestStarted]: FINAL_PERCENT, // 99
};
